<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "ModuleUpdated",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            const moduleType = this.$_.get(this.activity, "payload.type");
            const typeText = moduleType === "module" ? "modülünü" : "ilişkisini";
            return this.$t('notification.moduleUpdated', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                moduleName: this.$_.get(this.activity, 'payload.displayName'),
                moduleType: typeText
            });
        }
    }
};
</script>


